import fileService from '../../services/file';

const state = {
    bg: [],
    img: [],
    icons: [],
}

const getters = {
    bg: (state) => state.bg,
    img: (state) => state.img,
    icons: (state) => state.icons,
}

const actions = {
    getImages({ commit }) {
        return fileService.getImages()
            .then((response) => {
                commit('setImages', response.files);

                return response;
            })
    },
}

const mutations = {
    setImages(state, files) {
        state.bg = files.bg
        state.img = files.img
        state.icons = files.icons
    },
}

export const file = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}